export default {
	featureModeControls: {
		selectFeatureHint:
			"Veuillez sélectionner un trou / une découpe dans le modèle pour lui assigner une opération d'usinage (filetage, lamage, gravure, etc.).",
		differentTypesHint:
			"Plusieurs fonctionnalités ne peuvent être modifiées ensemble que si elles sont du même type (par ex. ajouter un filetage à plusieurs trous ronds).",
		andCutting: " et découpe",
		settingsLabel: "Paramètres :",
		pleaseSelectTool: "Veuillez sélectionner...",
		pressJoinCategories: {
			all: "Tous les inserts pressés",
			nut: "Écrou pressé",
			threadedStud: "Goujon fileté pressé",
			threadedBushing: "Douille filetée pressée",
		},
		noToolsForSide: "Malheureusement, aucun outil n'est disponible pour le côté sélectionné.",
		noToolsForMaterial: "Malheureusement, cette opération n'est pas disponible pour ce matériau.",
		apply: "Appliquer",
	},
	featurePanel: {
		minimize: "réduire",
		groups: {
			screwThread: "Filetages",
			countersink: "Lamages",
			extrudedThread: "Collerettes extrudées",
			cylinderHeadBoltHole: "Lamages pour vis à tête cylindrique",
			pressJoin: "Inserts pressés",
			engraving: "Gravures",
			hole: "Trous ronds",
			cutout: "Découpes",
			weldline: "Cordons de soudure",
			anchorFace: "Côtés supérieurs",
			bottomFace: "Côtés inférieurs",
			sideFace: "Côtés extérieurs",
		},
		weldlineStatus: {
			cleaned: "meulé",
			uncleaned: "non meulé",
		},
		labels: {
			engraving: "Gravure {id}",
			diameter: "Diamètre : {value}mm",
			cutout: "Découpe {id}",
			weldline: "Cordon de soudure {id}",
			anchorFace: "Côté supérieur {id}",
			bottomFace: "Côté inférieur {id}",
			sideFace: "Côté extérieur {id}",
			weldlineTitle: "ID {id} - {length} mm",
			weldlineCornerSingular: " + coin",
			weldlineCornerPlural: " + coins",
		},
		undetermined: "Indéterminé",
	},
	structurePanel: {
		minimize: "réduire",
	},
	articlePanel: {
		minimize: "réduire",
		blexonNumber: "N° Blexon :",
		material: "Matériau :",
		dimensions: "L x l x H :",
		saveAndClose: "Enregistrer et fermer",
		underReview: "En cours de vérification",
		sendToHelpdesk: "Envoyer au service d'assistance",
		additionalDesignation: {
			groundFoil: " / brossé / film",
			foil: " / film",
			ribbed: " / strié",
		},
	},
};
